import { MainApi } from "./MainApi";
import { FileClassification } from "../types/file";

export class FileApi {
  static baseUrl = `${MainApi.urlPrefix}/user/file`;
  static uploadImageFiles = (formData: FormData, fileClassification: FileClassification) =>
    MainApi.api.post(`${FileApi.baseUrl}/image?classification=${fileClassification}`, formData);
}
